export default __webpack_public_path__ + "7223003907e4bd0f903ecbca8aa3294e.png";